import { Button } from "@/components/catalyst/button";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { useContactRecord } from "@/app/Contacts/Hooks/useContactRecord";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { generateInvoicesForContactMutation } from "@/app/Contacts/GraphQL/contactGenerateInvoicesMutation";
import { toast } from "sonner";
import { useNavigate } from "@tanstack/react-router";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";

export function GenerateInvoicesButton() {
  const contact = useContactRecord();
  const navigate = useNavigate();
  const { mutateAsync } = useGqlMutation(generateInvoicesForContactMutation);
  const { isAdmin } = useTenant();

  async function handleGenerateInvoices() {
    const result = await mutateAsync({
      contactId: contact.id,
      asDraft: true,
    });

    const invoices = result.generateInvoicesForContact;

    if (invoices.length === 0) {
      toast.info("No invoices to generate");
      return;
    }

    toast.success(
      `Generated ${invoices.length} draft invoice${invoices.length > 1 ? "s" : ""}`,
    );

    if (invoices.length === 1) {
      navigate({
        to: "/$tenant/$orgId/supplier/{-$supplierId}/invoices/$id",
        params: (prev) => ({ ...prev, id: invoices[0].id }),
      });
    }
  }

  if (!isAdmin) {
    return null;
  }

  return (
    <Button onClick={handleGenerateInvoices}>
      <DocumentTextIcon />
      Generate invoices
    </Button>
  );
}
